module.exports = __webpack_public_path__ + "static/media/YUma weaving prt 1 v3.39528bc3.mp4";